module.exports = __webpack_public_path__ + "img/toggles2.d08831c7.svg";